var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.375 3.59271C19 1.29687 15.875 0 12.5469 0C2.99479 0 -3.00312 10.349 1.76667 18.5812L0 25L6.59896 23.2792C9.47396 24.8323 11.8292 24.6948 12.5531 24.7865C23.6292 24.7865 29.1427 11.3865 21.3594 3.63333L21.375 3.59271Z",
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5698 22.6573L12.5635 22.6563H12.5469C9.23229 22.6563 7.11458 21.0865 6.90625 20.9958L3 22.0115L4.04688 18.2146L3.79792 17.824C2.76667 16.1823 2.21875 14.2917 2.21875 12.3448C2.21875 3.18542 13.4115 -1.39479 19.8885 5.07917C26.35 11.4854 21.8135 22.6573 12.5698 22.6573Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2365 14.9031L18.2271 14.9813C17.9136 14.825 16.3865 14.0781 16.1021 13.975C15.4636 13.7386 15.6438 13.9375 14.4177 15.3417C14.2354 15.5448 14.0542 15.5604 13.7448 15.4198C13.4323 15.2636 12.4292 14.9354 11.2417 13.8729C10.3167 13.0448 9.69585 12.0292 9.51252 11.7167C9.20731 11.1896 9.84585 11.1146 10.4271 10.0146C10.5313 9.79585 10.4781 9.62397 10.4011 9.46876C10.3229 9.31251 9.70106 7.78126 9.44065 7.17085C9.19065 6.56251 8.93335 6.6396 8.74065 6.6396C8.14065 6.58751 7.7021 6.59585 7.31565 6.99793C5.6344 8.84585 6.05835 10.7521 7.4969 12.7792C10.324 16.4792 11.8302 17.1604 14.5844 18.1063C15.3281 18.3427 16.0063 18.3094 16.5427 18.2323C17.1406 18.1375 18.3834 17.4813 18.6427 16.7469C18.9084 16.0125 18.9084 15.4031 18.8302 15.2625C18.7531 15.1219 18.549 15.0438 18.2365 14.9031V14.9031Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappFilled);
export default __webpack_public_path__ + "static/media/whatsapp-filled.0fb193ec.svg";
export { ForwardRef as ReactComponent };